import React from 'react';
import PropTypes from 'prop-types';

import { SAVED_CONTACTS_RECORD_ID_QUERY } from '@general/graphql/contact.graph';
import { mapSearchMemberToProps } from '@general/transforms/member.transform';
import MemberCardRedesign from '@molecules/MemberCardRedesign';
import MemberListItemRedesign from '@molecules/MemberListItemRedesign';
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';

const algoliaIndex = 'members';
const SearchEventAttendees = ({
    defaultViewType,
    eventCode,
    hitsPerPage,
    showCalendarIcon = false,
    showFilters = false,
    showPagingToolbar = false,
    showSearchBox = false,
    showSearchOptions = false,
    onCalendarClick,
    NoResultsText = () => <>Looks like the event has no attendees yet. Check back closer to the event.</>,
}) => {
    return (
        <SearchModeContext.Provider value={{ showFilters }}>
            <Search
                filters={`events_attended.code:${eventCode}`}
                defaultViewType={defaultViewType}
                index={algoliaIndex}
                displayPagingToolbar={showPagingToolbar}
                displaySearchBox={showSearchBox}
                displaySearchOptions={showSearchOptions}
                hitsPerPage={hitsPerPage}
            >
                <SearchResults
                    cardComponent={props => (
                        <MemberCardRedesign
                            {...props}
                            showCalendarIcon={showCalendarIcon}
                            onCalendarClick={member => onCalendarClick(member, algoliaIndex)}
                        />
                    )}
                    listItemComponent={props => (
                        <MemberListItemRedesign
                            {...props}
                            showCalendarIcon={showCalendarIcon}
                            onCalendarClick={member => onCalendarClick(member, algoliaIndex)}
                        />
                    )}
                    index={algoliaIndex}
                    NoResultsText={NoResultsText}
                    query={SAVED_CONTACTS_RECORD_ID_QUERY}
                    transformFunc={mapSearchMemberToProps}
                    typePlural="contacts"
                    resultsPerRow={2}
                />
            </Search>
        </SearchModeContext.Provider>
    );
};

SearchEventAttendees.propTypes = {
    defaultViewType: PropTypes.string,
    eventCode: PropTypes.string.isRequired,
    hitsPerPage: PropTypes.number,
    showCalendarIcon: PropTypes.bool,
    showFilters: PropTypes.bool,
    showPagingToolbar: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    showSearchOptions: PropTypes.bool,
    NoResultsText: PropTypes.elementType,
    onCalendarClick: PropTypes.func,
};

export default SearchEventAttendees;
